import { createTheme } from "@mui/material";



let baseTheme = createTheme();
export const SCCOTheme = createTheme(baseTheme, {
    typography: {
        fontFamily: ['"Barlow Condensed"', "sans-serif"].join(',')
    },
    palette: {
        ...baseTheme.palette,
        primary: {
            main: '#d7282f'
        }
    }
});
